import { useState, useCallback, useMemo, useEffect } from 'react';
import { downloadDocumentFromUrl } from '../../utils/helpers';
import { Modal, Button, Table, Form, InputGroup, Row, Col } from 'react-bootstrap';
import { getBusinessPartner } from '../../utils/api';
import Loader from '../Loader';
import Header from '../Header';
import { faCar, faEllipsis, faTrashCan, faArrowsTurnToDots, faPencil, faPlus, faCirclePlus, faFile, faCloudDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { formatCurrency, formatDateToMMDDYYYYWithTime, openDocumentInNewTab } from '../../utils/helpers';
import ShowMenuButton from '../ShowMenuButton';
import Error from '../Error';

const ViewBusinessPartnerModal = ({ show, onHide, businessPartner }) => {

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const [data, setData] = useState([]);

    useEffect(() => {
        fetchData();
    }, [show]);

    const fetchData = async () => {
        if (show) {
            setLoading(true);
            setError(null);
            const data = businessPartner && await getBusinessPartner(businessPartner.Id);
            if (data) {
                setData(data);
            }
            else {
                setError('Failed to fetch business Partner');
            }
            setLoading(false);
        }
        else {
            setData([]);
            setError(null);
            setLoading(false);
        }
    };

    return (
        <>
            <Modal show={show} onHide={onHide} size="xl" style={{ zIndex: 1050 }} centered>
                <Modal.Header closeButton>
                    <Modal.Title>View Business Partner (Id={businessPartner?.Id})</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div style={{ padding: 10 }}>
                        {loading ? <Loader /> : error ? <Error /> : (
                            <>
                                <Header title={businessPartner?.Vin} description="Details pertaining to the business partner" />
                                <Row>
                                    <Table striped bordered hover responsive>
                                        <thead>
                                            <tr>
                                                <th style={{ whiteSpace: 'nowrap', }}>
                                                    ID
                                                </th>
                                                <th tyle={{ whiteSpace: 'nowrap', }}>
                                                    Name
                                                </th>
                                                <th style={{ whiteSpace: 'nowrap', }}>
                                                    TaxIdNumber
                                                </th>
                                                <th style={{ whiteSpace: 'nowrap', }}>
                                                    BusinessPartnerNumber
                                                </th>
                                                <th style={{ whiteSpace: 'nowrap', }}>
                                                    BusinessPartnerType
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {[data]?.map((d, idx) => (
                                                <tr key={idx}>
                                                    <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle' }}>{d?.Id}</td>
                                                    <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle' }}>{d?.Name}</td>
                                                    <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle' }}>{d?.TaxIdNumber}</td>
                                                    <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle' }}>{d?.BusinessPartnerNumber}</td>
                                                    <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle' }}>{d?.BusinessPartnerType?.Description}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </Row>
                                <br /><br />
                                <Row>
                                    <div>
                                        <div style={{ marginBottom: '8px', fontWeight: 'bold', display: 'flex', justifyContent: 'space-between', }}>
                                            Address
                                        </div>

                                        <Table striped bordered hover responsive>
                                            <thead>
                                                <tr>
                                                    <th style={{ whiteSpace: 'nowrap', }}>
                                                        Id
                                                    </th>
                                                    <th style={{ whiteSpace: 'nowrap', }}>
                                                        AddressLine1
                                                    </th>
                                                    <th style={{ whiteSpace: 'nowrap', }}>
                                                        AddressLine2
                                                    </th>
                                                    <th style={{ whiteSpace: 'nowrap', }}>
                                                        City
                                                    </th>
                                                    <th style={{ whiteSpace: 'nowrap', }}>
                                                        State
                                                    </th>
                                                    <th style={{ whiteSpace: 'nowrap', }}>
                                                        PostalCode
                                                    </th>
                                                    <th style={{ whiteSpace: 'nowrap', }}>
                                                        Country
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {[data]?.map((d, idx) => (
                                                    <tr key={idx}>
                                                        <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle' }}>{d?.Address?.Id}</td>
                                                        <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle' }}>{d?.Address?.AddressLine1}</td>
                                                        <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle' }}>{d?.Address?.AddressLine2}</td>
                                                        <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle' }}>{d?.Address?.City}</td>
                                                        <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle' }}>{d?.Address?.State}</td>
                                                        <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle' }}>{d?.Address?.PostalCode}</td>
                                                        <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle' }}>{d?.Address?.Country}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    </div>
                                </Row>
                            </>
                        )}
                    </div>
                </Modal.Body>

            </Modal >
        </>
    );
};

export default ViewBusinessPartnerModal;